import React from "react";
import { observer } from "mobx-react";
import List from "../../components/List";
import AuthenticationStore from "../../stores/AuthenticationStore";
import Stores from "../../stores/Stores";
import UIStore from "../../stores/UIStore";
import Edit from "./Edit";
import SearchField from "../../components/SearchField";
import SortPanel from "../../components/SortPanel";
import SelectPanel from "../../components/SelectPanel";
import dayjs from "dayjs";


const store = Stores.load("users");
const producerType = {
  BREWER: "Cervejeiro",
  BREWERY: "Cervejaria",
};
const PRODUCER_TYPE_OPTIONS = [
  { value: "BREWER", label: "Cervejeiro" },
  { value: "BREWERY", label: "Cervejaria" },
];

class Users extends React.Component {
  componentDidMount() {
    UIStore.init("Usuários", store);
  }

  handleDelete = () => {
    let count = store.selected.length;

    UIStore.showConfirmDialog(
      `Deseja remover ${count} usuários?`,
      "Remover Usuários"
    ).then((b) => {
      if (b) {
        store
          .delete()
          .then(() => store.query())
          .catch(() => alert("Erro!"));
      }
    });
  };

  handleFilter = () => {
    store.page = 0;
    store.searchAll = !store.searchAll;
    store.query();
  };

  render() {
    let toggleFilters = (
      <ul className="filters-list">
        <li>
          <div
            className={!store.searchAll ? "activated" : ""}
            onClick={this.handleFilter}
          >
            Liberados
          </div>
        </li>
        <li>
          <div
            className={store.searchAll ? "activated" : ""}
            onClick={this.handleFilter}
          >
            Todos
          </div>
        </li>
      </ul>
    );

    let canEdit;
    if (AuthenticationStore.me.role === "MANAGER") {
      canEdit = false;
    } else {
      canEdit = true;
    }

    return (
      <>
        <List
          store={store}
          data={store.list.map((i) => ({
            item: i,
            title: (!!i.name ? i.name : "Sem nome") + " (" + i.email + ")",
            content: (
              <>
                Adicionado em:{" "}
                {i.createdDate ? i.createdDate.formatTimeStamp() : ""}
                <br />
                Papel: {i.role}
                <br />
                Tipo de conta:{" "}
                {!!i.producerType ? producerType[i.producerType] : "Não definido"}
                <br />
                Último acesso:{" "}
                {!!i.lastAccess ? dayjs(i.lastAccess).format("DD/MM/YYYY HH:mm") : ""}
              </>
            ),
          }))}
          status={store.list.map((i) => ({
            id: i.id,
            label: i.enabled ? "Liberado" : "Desativado",
            class: i.enabled ? "finished-status" : "canceled-status",
          }))}
          rightPanel={
            <>
              <SortPanel
                store={store}
                filters={{
                  name: "Nome",
                  email: "Email",
                  createdDate: "Data de Adição",
                  lastAccess: "Último acesso",
                }}
              />
              <SearchField store={store} />
            </>
          }
          leftPanel={
            <>
              <SelectPanel
                store={store}
                options={PRODUCER_TYPE_OPTIONS}
                label="Tipo"
                getLabel={(item) => !!item ? item.label : "Todos"}
                entity="producerType"
              />
              {toggleFilters}
            </>
          }
          onEdit={canEdit ? () => store.open() : null}
          onDelete={canEdit ? () => this.handleDelete() : null}
        />

        <Edit onSave={() => AuthenticationStore.testAuthenticated()} />
      </>
    );
  }
}

export default observer(Users);
